/* global axios */
// Inbound calling, office hours, missed calls and recordings, through Relay.
const account = accountId => `/api/v1/accounts/${accountId}`;
const voice = accountId => `${account(accountId)}/relay_voice`;
const manager = accountId => `${account(accountId)}/relay_voice_manager`;
const data = request => request.then(r => r.data);

// Office hours (chat and phone) and the after-hours chat wording: team leads and administrators.
export const getOfficeHours = accountId =>
  data(axios.get(`${account(accountId)}/squareme_office_hours`));

export const saveOfficeHours = (accountId, hours) =>
  data(axios.put(`${account(accountId)}/squareme_office_hours`, hours));

// The Customer Success queue, who can take calls now, recording retention and
// the outbound premium-rate blocklist (Relay Voice, through Relay).
export const getInboundSettings = accountId =>
  data(axios.get(`${manager(accountId)}/inbound_settings`));

export const saveInboundSettings = (accountId, settings) =>
  data(axios.put(`${manager(accountId)}/inbound_settings`, settings));

export const getInboundAgents = accountId =>
  data(axios.get(`${manager(accountId)}/inbound_agents`));

export const getRecordingSettings = accountId =>
  data(axios.get(`${manager(accountId)}/recording_settings`));

export const saveRecordingSettings = (accountId, settings) =>
  data(axios.put(`${manager(accountId)}/recording_settings`, settings));

export const getOutboundPolicy = accountId =>
  data(axios.get(`${manager(accountId)}/outbound_policy`));

export const saveOutboundPolicy = (accountId, policy) =>
  data(axios.put(`${manager(accountId)}/outbound_policy`, policy));

// The missed-call list (the team's callback queue).
export const getMissedCalls = (accountId, params = {}) =>
  data(axios.get(`${voice(accountId)}/missed_calls`, { params }));

export const getMissedCallSummary = accountId =>
  data(axios.get(`${voice(accountId)}/missed_calls/summary`));

// action: claim | assign | release | called_back | reopen
export const updateMissedCall = (accountId, callId, action, body = {}) =>
  data(
    axios.post(`${voice(accountId)}/missed_calls/${callId}/${action}`, body)
  );

// Five-minute signed links: { url, expires_at }.
export const callRecordingLink = (accountId, callId, download = false) =>
  data(
    axios.post(`${voice(accountId)}/calls/${callId}/recording_link`, {
      download,
    })
  );

export const callerMessageLink = (accountId, callId, download = false) =>
  data(
    axios.post(`${voice(accountId)}/missed_calls/${callId}/message_link`, {
      download,
    })
  );

// An answered caller with no conversation yet: contact (created when unknown) and a phone conversation.
export const ensureCaller = (accountId, number) =>
  data(axios.post(`${voice(accountId)}/inbound_contact`, { number })).then(
    r => r.data
  );
